import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../state/store';

const PrivateWrapper = () => {
    const { accessToken, isAuthenticated, role } = useSelector((state: RootState) => state.auth);

    if (!accessToken || !isAuthenticated || !role) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default PrivateWrapper;
